export default {
  EXIT_POLL_OPTIONS_REPOSITORY: Symbol.for('EXIT_POLL_OPTIONS_REPOSITORY'),
  GET_EXIT_POLL_OPTIONS_QUERY: Symbol.for('GET_EXIT_POLL_OPTIONS_QUERY'),
  EXIT_POLL_OPTIONS_STATE_MANAGER: Symbol.for('EXIT_POLL_OPTIONS_STATE_MANAGER'),
};
